import { Routes } from '@angular/router';
import {LoginComponent} from "../components/login/login.component";
import {ResetPasswordComponent} from "../components/reset-password/reset-password.component";
import {SignupComponent} from "../components/signup/signup.component";
import {DashboardComponent} from "../components/dashboard/dashboard.component";



export const PUBLIC_ROUTES: Routes = [
    { path: '', component: DashboardComponent },
    { path: 'login', component: LoginComponent },
    { path: 'signup', component: SignupComponent },
    { path: 'reset-password', component: ResetPasswordComponent }
];



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/constants/public.routes.ts